import { apiGet } from './httpClient'
import type { NearbyResult } from './types'

export function getNearby(
  tripId: string,
  lat: number,
  lng: number,
  radiusM?: number,
): Promise<NearbyResult> {
  const q = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
    ...(radiusM != null ? { radius_m: String(radiusM) } : {}),
  })
  return apiGet<NearbyResult>(`/trips/${tripId}/nearby?${q}`)
}
